import PropTypes from 'prop-types'


const Seo = data => ({
  title: data.title,
  description: data.description,
  keywords: data.keywords,
  image: data.image?.file?.url,
})

Seo.propTypes = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  image: PropTypes.string,
})

Seo.defaultProps = {
  title: '',
  description: '',
  keywords: '',
  image: '',
}

export default Seo
